import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import DoDisturbOffIcon from '@mui/icons-material/DoDisturbOff';
import DoDisturbOnIcon from '@mui/icons-material/DoDisturbOn';
import HomeIcon from '@mui/icons-material/Home';
import ImageIcon from '@mui/icons-material/Image';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SendIcon from "@mui/icons-material/Send";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import ConfirmAction from "../../components/Common/ConfirmAction";
import { deleteActualite, updateActualite } from "../../store/siteWebSlice";
import { SITEWEB_SERVER_BASE_URL, apiClient } from "../../util/apiClient";
import { convertToBase64, errorNotify, successNotify } from "../../util/functions";
import PostEditDialog from "../components/PostEditDialog";
import Edit from "./Edit";
import EditGalerie from "./EditGalerie";
import { IEditionActualitePayload } from "./interface";


export default function MenuApp(props: any) {
  //props
  const { item } = props;

  //redux
  const dispatch = useDispatch();

  //hooks
  //Menu
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  //edition actualite
  const [editLoading, setEditUserLoading] = useState<boolean>(false);
  const [openEdition, setOpenEdition] = useState<boolean>(false);
  const [editActualite, setEditActualite] = useState<any>({})
  const [selectedPhoto, setSelectedPhoto] = useState<any>("")

  // active ou desactive
  const [openActiveDesactive, setOpenActiveDesactive] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  //suppression
  const [openSuppression, setOpenSuppression] = useState<boolean>(false)
  const [suppressionLoading, setSuppressionLoading] = useState<boolean>(false);

  //à la une
  const [openAlaUne, setOpenAlaUne] = useState<boolean>(false)
  const [alaUneLoading, setAlaUneLoading] = useState<boolean>(false);


  //Galerie
  const [openEditionGalerieDialog, setOpenEditionGalerieDialog] = useState<boolean>(false)
  const [loadingEditionGalerie, setLoadingEditionGalerie] = useState<boolean>(false)
  const [arrayGalerieToEdit, setArrayGalerieToEdit] = useState<any>([])


  //Ouvrir le menu
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  //Fermer le menu
  const handleClose = () => {
    setAnchorEl(null);
  };



  ///////////////////////////////////// Mettre ou enlever une actualité sur le site /////////////////////////////////////////////////
  //Ouvrir la boite de confirmation ActiveDesactive
  const handleActiveDesactiveDialogOpen = () => {
    setOpenActiveDesactive(true);
  };

  //Fermer la boite de confirmation ActiveDesactive
  const handleActiveDesactiveDialogClose = () => {
    setOpenActiveDesactive(false);
  };


  //Mettre une actualité à la une ou l'enlever
  const handleSave = async (e: any) => {
    e.preventDefault();
    try {
      setLoading(true);

      //constituer le payload
      const apiPayload = {
        idActualite: item.idActualite,
        active: item.active === 1 ? 0 : 1
      };

      //Envoie de la requete vers l'api
      const res: any = await apiClient.post(
        SITEWEB_SERVER_BASE_URL,
        "/activeoudesactiveactualite",
        apiPayload
      );

      if (res.status === 1) {
        dispatch(updateActualite(res.data));
        setLoading(false);
        handleActiveDesactiveDialogClose();
        successNotify("Action éffectuée avec succès");
      } else {
        setLoading(false);
        errorNotify("Echèc de l'opération.");
      }
    } catch (error) {
      console.log("🚀 ~ file: MenuApp.tsx:108 ~ handleSave ~ error:", error)
      setLoading(false);
      errorNotify("Une erreur s'est produite.");
    }
  };


  ///////////////////////////////////////// edition Galerie  ///////////////////////////////////////////////////
  //Ouvrir la boite de dialog puis mise à jour de l'objet editActualite
  const handleEditionGalerieDialogOpen = (item: any) => {
    setOpenEditionGalerieDialog(true);
    setEditActualite(item)
  };

  //Fermer la boite de dialog d'edition 
  const handleEditionGalerieDialogClose = () => {
    setOpenEditionGalerieDialog(false);
  };



  /**
 * Permet d'enregistrer les modifiaction apportées 
 * sur la galerie d'une actualité dans la base de donnée
 * @param e 
 */
  const handlEditGalerieSave = async (e: any) => {
    e.preventDefault();
    try {
      setLoadingEditionGalerie(true);

      //Obtenir un tableau d'élèment des images de la galérie en base 64
      let galerieImageEnBase64: string[] = []
      arrayGalerieToEdit.map(async (item: any) => {
        galerieImageEnBase64.push(item.url)
      })

      // Constituer le payload
      const apiPayload: any = {
        idActualite: editActualite.idActualite,
        galerieImageEnBase64: galerieImageEnBase64 ? galerieImageEnBase64 : [],
      }

      //Envoie de la requete vers l'api
      const res: any = await apiClient.post(
        SITEWEB_SERVER_BASE_URL,
        "/modifiergalerie",
        apiPayload
      );

      if (res.status === 1) {
        dispatch(updateActualite(res.data));
        setLoadingEditionGalerie(false);
        successNotify("Action éffectuée avec succès");
      } else {
        setLoadingEditionGalerie(false);
        errorNotify("Echèc de l'opération.");
      }
    } catch (error) {
      console.log("🚀 ~ file: MenuApp.tsx:108 ~ handleSave ~ error:", error)
      setLoadingEditionGalerie(false);
      errorNotify("Une erreur s'est produite.");
    }
  };



  ///////////////////////////////////////// edition d'une actualité ///////////////////////////////////////////////////
  //Ouvrir la boite de dialog puis mise à jour de l'objet editActualite
  const handleEditionDialogOpen = (item: any) => {
    setOpenEdition(true);
    setEditActualite(item)
  };

  //Fermer la boite de dialog d'edition 
  const handleEditionDialogClose = () => {
    setOpenEdition(false);
  };


  // Modifier une actualité dans la bd
  const handleiditActualiteSave = async (e: any) => {
    e.preventDefault();
    try {
      setEditUserLoading(true);

      //Obtenir l'image descriptive de l'actualité
      const actualiteImageEnBase64: string | undefined | unknown = selectedPhoto ? await convertToBase64(selectedPhoto) : "";

      //constituer le payload
      const apiPayload: IEditionActualitePayload = {
        idActualite: editActualite.idActualite,
        titre: editActualite.titre,
        sousTitre: editActualite.sousTitre,
        dateActualite: editActualite.dateActualite,
        texteComplet: editActualite.texteComplet,
        actualiteImage: editActualite.actualiteImage,
        actualiteImageEnBase64: actualiteImageEnBase64,
        idCategorie: editActualite.idCategorie
      }

      // envoyer la requete vers api
      const res: any = await apiClient.post(
        SITEWEB_SERVER_BASE_URL,
        "/modifieractualite",
        apiPayload
      );

      if (res.status === 1) {
        dispatch(updateActualite(res.data));
        setEditUserLoading(false);
        // handleActiveDesactiveDialogClose();
        successNotify("Action éffectuée avec succès");
      } else {
        setEditUserLoading(false);
        errorNotify("Echèc de l'opération.");
      }
    } catch (error) {
      console.log("🚀 ~ file: MenuApp.tsx:108 ~ handleSave ~ error:", error)
      setEditUserLoading(false);
      errorNotify("Une erreur s'est produite.");
    }
  };


  /////////////////////////////////////////////////  suppression  /////////////////////////////////////////////////////////
  //Ouvrir la boite de dialog suppression
  const handleSuppressionDialogOpen = () => {
    setOpenSuppression(true);
  };

  //Fermer la boite de dialog suppression
  const handleSuppressionDialogClose = () => {
    setOpenSuppression(false);
  };

  //Supprimer une actualité dans la bd
  const handleDelete = async (e: any) => {
    e.preventDefault();
    try {
      setSuppressionLoading(true);

      //constituer le payload
      const apiPayload = {
        idActualite: item.idActualite
      };

      // envoyer la requete vers api
      const res: any = await apiClient.post(
        SITEWEB_SERVER_BASE_URL,
        "/supprimeractualite",
        apiPayload
      );

      if (res.status === 1) {
        dispatch(deleteActualite(res.data));
        setSuppressionLoading(false);
        handleSuppressionDialogClose();
        successNotify("Action éffectuée avec succès");
      } else {
        setSuppressionLoading(false);
        errorNotify("Echèc de l'opération.");
      }
    } catch (error) {
      console.log("🚀 ~ file: MenuApp.tsx:225 ~ handleDelete ~ error:", error)
      setSuppressionLoading(false);
      errorNotify("Une erreur s'est produite.");
    }
  };

  /////////////////////////////////////////////////////// A la une  ////////////////////////////////////////////////////////
  //Ouvrir la boite de dialog A la une
  const handleAlaUneDialogOpen = () => {
    setOpenAlaUne(true);
  };

  //Fermer la boite de dialog A la une
  const handleAlaUneDialogClose = () => {
    setOpenAlaUne(false);
  };

  //Mettre une actualité à la une
  const handleAlaUneSave = async (e: any) => {
    e.preventDefault();
    try {
      setAlaUneLoading(true);

      //constitution du payload
      const apiPayload = {
        idActualite: item.idActualite,
        status: item.aLaUne === 1 ? 0 : 1
      };

      //Envoie de la requete vers l'api
      const res: any = await apiClient.post(
        SITEWEB_SERVER_BASE_URL,
        "/mettreactualitealaune",
        apiPayload
      );

      if (res.status === 1) {
        dispatch(updateActualite(res.data));
        setAlaUneLoading(false);
        handleAlaUneDialogClose();
        successNotify("Action éffectuée avec succès");
      } else {
        setAlaUneLoading(false);
        errorNotify("Echèc de l'opération.");
      }
    } catch (error) {
      console.log("🚀 ~ file: MenuApp.tsx:108 ~ handleSave ~ error:", error)
      setAlaUneLoading(false);
      errorNotify("Une erreur s'est produite.");
    }
  };





  return (
    <React.Fragment>
      <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
        <Tooltip title="Options">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <MoreVertIcon />
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem
          onClick={() => {
            handleActiveDesactiveDialogOpen();
          }}

        >
          <ListItemIcon>
            {item.active === 0
              ? <DoDisturbOffIcon fontSize="small" color="error" />
              : <DoDisturbOnIcon fontSize="small" />

            }
          </ListItemIcon>
          {item.active === 0
            ? "Désactiver"
            : "Activer"
          }
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleEditionDialogOpen(item);
          }}
        >
          <ListItemIcon>
            <CreateIcon fontSize="small" />
          </ListItemIcon>
          Modifier
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleSuppressionDialogOpen();
          }}
        >
          <ListItemIcon>
            <DeleteIcon fontSize="small" />
          </ListItemIcon>
          Supprimer
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleAlaUneDialogOpen();
          }}
        >
          <ListItemIcon>
            <ListItemIcon>
              {item.aLaUne === 0
                ? <HomeIcon fontSize="small" color="primary" />
                : <HomeIcon fontSize="small" />

              }
            </ListItemIcon>
          </ListItemIcon>
          A la une
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleEditionGalerieDialogOpen(item);
          }}
        >
          <ListItemIcon>
            <ImageIcon fontSize="small" />
          </ListItemIcon>
          Galérie
        </MenuItem>
      </Menu>


      {/* Activer ou désactiver l'actualité */}
      <ConfirmAction
        title={`${item.active === 0 ? "Désactiver" : "Activer"} l'actualité`}
        dialogContent={`Voulez vous réellement effectuer cette opération?`}
        actionLabel="Valider"
        open={openActiveDesactive}
        handleClose={handleActiveDesactiveDialogClose}
        actionFunction={handleSave}
        addLoading={loading}
        iconeSauveButton={<SendIcon />}
      />

      {/* editer une actualité */}

      <PostEditDialog
        onClose={handleEditionDialogClose}
        open={openEdition}
        dialogContent={
          <Edit
            editActualite={editActualite}
            setEditActualite={setEditActualite}
            selectedPhoto={selectedPhoto}
            setSelectedPhoto={setSelectedPhoto}
          />}
        actionFunc={handleiditActualiteSave}
        title="Edition"
        editLoading={editLoading}
      />


      {/* edition de la galerie */}
      <PostEditDialog
        onClose={handleEditionGalerieDialogClose}
        open={openEditionGalerieDialog}
        dialogContent={
          <EditGalerie
            arrayGalerieToEdit={arrayGalerieToEdit}
            setArrayGalerieToEdit={setArrayGalerieToEdit}
          />}
        actionFunc={handlEditGalerieSave}
        title="Galérie"
        editLoading={loadingEditionGalerie}
      />

      {/* Supprimer l'actualité */}
      <ConfirmAction
        title={`Suppression`}
        dialogContent={`Voulez vous réellement supprimer cette actualité ?`}
        actionLabel="Oui"
        open={openSuppression}
        handleClose={handleSuppressionDialogClose}
        actionFunction={handleDelete}
        addLoading={suppressionLoading}
        iconeSauveButton={<DeleteIcon />}
      />


      {/* Mettre l'actualité à la une */}
      <ConfirmAction
        title={`A la une`}
        dialogContent={`${item.aLaUne === 0 ? "Voulez vous réellement mettre " : "Voulez vous réellement enlever"} cette actualité à la une?`}
        actionLabel="Oui"
        open={openAlaUne}
        handleClose={handleAlaUneDialogClose}
        actionFunction={handleAlaUneSave}
        addLoading={alaUneLoading}
        iconeSauveButton={<SendIcon />}
      />

    </React.Fragment>
  );
}
